import React from "react";
import ReactDOM from "react-dom";
import Navbar from "../../containers/Navbar/Navbar";

const PortalNavbar = () => ReactDOM.createPortal(<Navbar />, document.getElementById("navbar"));

export default PortalNavbar;
